angular.module("digitalLeasing.module").component("nuovoPrestoLeasing", {
  templateUrl: "ng/components/digitalLeasing/nuovoPrestoLeasing/nuovoPrestoLeasing.view.html",
  bindings: {
    model: "=",
    exportValidityNuovoPrestoLeasing: "&",
  },
  controllerAs: "nuovoPrestoLeasingCtrl",
  controller: function NuovoPrestoLeasing($financialApiService) {
    var self = this;

    self.$onInit = function () {
      jQuery(".alb-scroll.recovery-scroll").mCustomScrollbar("scrollTo", 0); //posiziona la scollBar in top ad ogni cambio vista
      self.questionario = self.model.leasingData.preventivo.questionarioNuovoPrestoleasing

      if (self.model.leasingData.preventivo.questionarioNuovoPrestoleasing.length == 0) {
        self.isPending = true;
        var cdConvenzionePrm = self.model.leasingData.preventivo.convenzionePrm && self.model.leasingData.preventivo.convenzionePrm.cdConvenzione
        $financialApiService
          .getQuestionarioNpl(self.model.leasingData.preventivo.prodotto.id, cdConvenzionePrm)
          .then(function (response) {
            self.questionario = response;
            self.isPending = false;
          })
          .catch(function (error){
            self.isPending = false;
            console.log("ERROR:", error);
          }); 
      }
    };

    self.exportValidityQuestionario = function (validity) {
      self.exportValidityNuovoPrestoLeasing({
        validity: validity
      })
    }

    self.checkPrestoLeasingIsOk = function(prestoLeasingIsOk) {
      self.prestoLeasingIsOk = prestoLeasingIsOk;
    }
  }
})